enum LOG_ELECTRON  {
   LEVEL = 'log_level',
   COUNT = 'log_count',
	EVENT = 'log_event',
	DATA = 'log_data',

}

enum LOG_EVENT {
   E_LOAD = 'pagina-load',
   E_LOGIN = 'login',
   E_ACEPTAR_TERMINO = 'acepto-terminos' ,
   E_NO_ACEPTO_TERMINO = 'no-acepto-termino',
   E_INICIAR_SIMULACION = 'iniciar-simulacion',
   E_INICIAR_PRUEBA = 'iniciar-prueba',
   E_CONTINUAR_PRUEBA = 'continuar-prueba', 
   E_FINALIZA_PRUEBA = 'finaliza-prueba',
   E_PETICION = 'peticion'
}

enum LOG_LEVEL {
   ERROR = "0",
   INFO = "1",
}

export {LOG_ELECTRON, LOG_EVENT, LOG_LEVEL}